import React from "react";
import "./index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ChatWidget from "./components/ChatWidget";
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import PortfolioPage from "./pages/PortfolioPage";
import AboutPage from "./pages/AboutPage";
import ProcessPage from "./pages/ProcessPage";
import FAQPage from "./pages/FAQPage";
import ContactPage from "./pages/ContactPage";
import DevisPage from "./pages/DevisPage";
import LegalPage from "./pages/LegalPage";
import NotFoundPage from "./pages/NotFoundPage";
import ContactProPage from "./pages/ContactProPage";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  React.useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

// Layout avec Navbar/Footer (pages principales)
const MainLayout = ({ children }) => (
  <>
    <Navbar />
    {children}
    <Footer />
    <ChatWidget />
  </>
);

// Layout sans Navbar/Footer (page secrète contact-pro)
const MinimalLayout = ({ children }) => children;

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div style={{ backgroundColor: '#0A1A1A', minHeight: '100vh' }}>
          <Routes>
            {/* Page secrète contact-pro - sans navbar/footer */}
            <Route path="/contact-pro" element={
              <MinimalLayout>
                <ContactProPage />
              </MinimalLayout>
            } />
            
            {/* Pages principales avec navbar/footer */}
            <Route path="/" element={<MainLayout><HomePage /></MainLayout>} />
            <Route path="/services" element={<MainLayout><ServicesPage /></MainLayout>} />
            <Route path="/realisations" element={<MainLayout><PortfolioPage /></MainLayout>} />
            <Route path="/a-propos" element={<MainLayout><AboutPage /></MainLayout>} />
            <Route path="/processus" element={<MainLayout><ProcessPage /></MainLayout>} />
            <Route path="/faq" element={<MainLayout><FAQPage /></MainLayout>} />
            <Route path="/contact" element={<MainLayout><ContactPage /></MainLayout>} />
            <Route path="/devis" element={<MainLayout><DevisPage /></MainLayout>} />
            <Route path="/legal" element={<MainLayout><LegalPage /></MainLayout>} />
            <Route path="*" element={<MainLayout><NotFoundPage /></MainLayout>} />
          </Routes>
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
